<template>
  <section class="excess-form">
    <template v-if="classId === 14">
      <div class="flex-sb">
        <div class="form-half">
          <div class="form-item">
            <span>Third Party Property Damage Excess</span>
            <v-input
              v-model="formData.tppd_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
          </div>
          <div class="form-item">
            <span>TPPD Young Driver Excess</span>
            <v-input
              v-model="formData.tppd_young_driver_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
          </div>
          <div class="form-item">
            <span>TPPD Inexperience Excess</span>
            <v-input
              v-model="formData.tppd_inexp_driver_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
          </div>
          <div class="form-item">
            <span>TPPD Unnamed Driver Excess</span>
            <v-input
              v-model="formData.tppd_unnamed_driver_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
          </div>
        </div>
        <div class="form-half">
          <div class="form-item">
            <span class="flex-title">Remark</span>
            <v-input
              v-model="formData.remark"
              type="textarea"
              :disabled="disabled"
              :rows="13" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="form.trm_of_cvr==2">
        <div class="form-item flex flex-sb">
          <div>
            <span class="flex-title">Own Damage</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.general_ex"
                :disabled="disabled"
                prepend="$"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
          <div>
            <span class="flex-title">Of Sum Insured</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.general_ex_posi"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
          <div>
            <span class="flex-title">Of Lost</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.general_ex_or_pol"
                :disabled="disabled"
                append="%"
                maxlength="8"
                :keyFloatNumber="true"
                @blur="submitExcessData"/>
            </div>
          </div>
          <!--            <v-checkbox-->
          <!--              v-model="excessCheckbox['general_ex'].status"-->
          <!--              :disabled="disabled">or</v-checkbox>-->
          <!--            <v-input-->
          <!--              v-model="formData.general_ex_vl"-->
          <!--              :disabled="!excessCheckbox['general_ex'].status||disabled"-->
          <!--              append="%" />-->
          <!--            <span>of</span>-->
          <!--            <v-select-->
          <!--              v-model="formData.general_ex_typ"-->
          <!--              :disabled="!excessCheckbox['general_ex'].status||disabled"-->
          <!--              :list="excessOptions"  />-->

        </div>
        <div class="form-item flex flex-sb">
          <div>
            <span class="flex-title">Own Damage (China) </span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_general_ex"
                :disabled="disabled"
                prepend="$"
                maxlength="8"
                :keyFloatNumber="true"
                @blur="submitExcessData"/>
              <!--            <v-checkbox-->
              <!--              v-model="excessCheckbox['china_general_ex'].status"-->
              <!--              :disabled="disabled">or</v-checkbox>-->
              <!--            <v-input-->
              <!--              v-model="formData.china_general_ex_vl"-->
              <!--              :disabled="!excessCheckbox['china_general_ex'].status||disabled"-->
              <!--              append="%" />-->
              <!--            <span>of</span>-->
              <!--            <v-select-->
              <!--              v-model="formData.china_general_ex_typ"-->
              <!--              :disabled="!excessCheckbox['china_general_ex'].status||disabled"-->
              <!--              :list="excessOptions"  />-->
            </div>
          </div>
          <div>
            <span class="flex-title">Of Sum Insured</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_general_ex_posi"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
          <div>
            <span class="flex-title">Of Lost</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_general_ex_or_pol"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
        </div>
        <!--        <div class="form-item">-->
        <!--          <span>Own Damage (Guangdong) </span>-->
        <!--          <div class="flex-excess">-->
        <!--            <v-input-->
        <!--              v-model="formData.gd_general_ex"-->
        <!--              :disabled="disabled"-->
        <!--              prepend="$"-->
        <!--              @blur="submitExcessData"/>-->
        <!--            <v-checkbox-->
        <!--              v-model="excessCheckbox['gd_general_ex'].status"-->
        <!--              :disabled="disabled">or</v-checkbox>-->
        <!--            <v-input-->
        <!--              v-model="formData.gd_general_ex_vl"-->
        <!--              :disabled="!excessCheckbox['gd_general_ex'].status||disabled"-->
        <!--              append="%" />-->
        <!--            <span>of</span>-->
        <!--            <v-select-->
        <!--              v-model="formData.gd_general_ex_typ"-->
        <!--              :disabled="!excessCheckbox['gd_general_ex'].status||disabled"-->
        <!--              :list="excessOptions"  />-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="form-item flex flex-sb">
          <div>
            <span class="flex-title">Theft</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.theft_loss_ex"
                :disabled="disabled"
                prepend="$"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
              <!--              <v-checkbox-->
              <!--                  v-model="excessCheckbox['theft_loss_ex'].status"-->
              <!--                  :disabled="disabled">or</v-checkbox>-->
              <!--              <v-input-->
              <!--                  v-model="formData.theft_loss_ex_vl"-->
              <!--                  :disabled="!excessCheckbox['theft_loss_ex'].status||disabled"-->
              <!--                  append="%" />-->
              <!--              <span>of</span>-->
              <!--              <v-select-->
              <!--                  v-model="formData.theft_loss_ex_typ"-->
              <!--                  :disabled="!excessCheckbox['theft_loss_ex'].status||disabled"-->
              <!--                  :list="excessOptions"  />-->
            </div>
          </div>
          <div>
            <span class="flex-title">Of Sum Insured</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.theft_loss_ex_posi"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
          <div>
            <span class="flex-title">Of Lost</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.theft_loss_ex_or_pol"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
        </div>
        <div class="form-item flex flex-sb">
          <div>
            <span class="flex-title">Theft (China) </span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_theft_loss_ex"
                :disabled="disabled"
                prepend="$"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
              <!--              <v-checkbox-->
              <!--                  v-model="excessCheckbox['china_theft_loss_ex'].status"-->
              <!--                  :disabled="disabled">or</v-checkbox>-->
              <!--              <v-input-->
              <!--                  v-model="formData.china_theft_loss_ex_vl"-->
              <!--                  :disabled="!excessCheckbox['china_theft_loss_ex'].status||disabled"-->
              <!--                  append="%" />-->
              <!--              <span>of</span>-->
              <!--              <v-select-->
              <!--                  v-model="formData.china_theft_loss_ex_typ"-->
              <!--                  :disabled="!excessCheckbox['china_theft_loss_ex'].status||disabled"-->
              <!--                  :list="excessOptions"  />-->
            </div>
          </div>
          <div>
            <span class="flex-title">Of Sum Insured</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_theft_loss_ex_posi"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
          <div>
            <span class="flex-title">Of Lost</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.china_theft_loss_ex_or_pol"
                :disabled="disabled"
                append="%"
                :keyFloatNumber="true"
                maxlength="8"
                @blur="submitExcessData"/>
            </div>
          </div>
        </div>
        <!--        <div class="form-item">-->
        <!--          <span>Theft (Guangdong) </span>-->
        <!--          <div class="flex-excess">-->
        <!--            <v-input-->
        <!--              v-model="formData.gd_theft_loss_ex"-->
        <!--              prepend="$" />-->
        <!--            <v-checkbox-->
        <!--              v-model="excessCheckbox['gd_theft_loss_ex'].status"-->
        <!--              :disabled="disabled">or</v-checkbox>-->
        <!--            <v-input-->
        <!--              v-model="formData.gd_theft_loss_ex_vl"-->
        <!--              :disabled="!excessCheckbox['gd_theft_loss_ex'].status||disabled"-->
        <!--              append="%" />-->
        <!--            <span>of</span>-->
        <!--            <v-select-->
        <!--              v-model="formData.gd_theft_loss_ex_typ"-->
        <!--              :disabled="!excessCheckbox['gd_theft_loss_ex'].status||disabled"-->
        <!--              :list="excessOptions"  />-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="form-excess-half">
          <div class="form-item">
            <span>Parking </span>
            <v-input
              v-model="formData.parking_damage_ex"
              :disabled="disabled"
              prepend="$"
              :keyFloatNumber="true"
              maxlength="8"
              @blur="submitExcessData"/>
          </div>
          <div class="form-item">
            <span>Own Damage Young Driver</span>
            <v-input
              v-model="formData.young_driver_ex"
              :disabled="disabled"
              prepend="$"
              :keyFloatNumber="true"
              maxlength="8"
              @blur="submitExcessData"/>
          </div>
          <div class="form-item">
            <span>Own Damage Inexperienced Driver</span>
            <v-input
              v-model="formData.inexp_driver_ex"
              :disabled="disabled"
              prepend="$"
              :keyFloatNumber="true"
              maxlength="8"
              @blur="submitExcessData"/>
          </div>
          <div class="form-item">
            <span>Own Damage Unnamed Driver</span>
            <v-input
              v-model="formData.unnamed_driver_ex"
              :disabled="disabled"
              prepend="$"
              :keyFloatNumber="true"
              maxlength="8"
              @blur="submitExcessData"/>
          </div>
        </div>
      </div>
      <div class="form-item">
        <span>Third Party Property Damage </span>
        <v-input
          v-model="formData.tppd_ex"
          :disabled="disabled"
          prepend="$"
          maxlength="8"
          :keyFloatNumber="true"
          @blur="submitExcessData"/>
      </div>
      <div class="form-item">
        <span>Third Party Property Damage Young Driver </span>
        <v-input
          v-model="formData.tppd_young_driver_ex"
          :disabled="disabled"
          prepend="$"
          maxlength="8"
          :keyFloatNumber="true"
          @blur="submitExcessData"/>
      </div>
      <div class="form-item">
        <span>Third Party Property Damage Inexperienced Driver </span>
        <v-input
          v-model="formData.tppd_inexp_driver_ex"
          :disabled="disabled"
          prepend="$"
          maxlength="8"
          :keyFloatNumber="true"
          @blur="submitExcessData"/>
      </div>
      <div class="form-item">
        <span>Third Party Property Damage Unnamed Driver </span>
        <v-input
          v-model="formData.tppd_unnamed_driver_ex"
          :disabled="disabled"
          prepend="$"
          maxlength="8"
          :keyFloatNumber="true"
          @blur="submitExcessData"/>
      </div>
      <!--        <div class="form-item">-->
      <!--          <span>Remark</span>-->
      <!--          <v-input-->
      <!--            v-model="formData.remark"-->
      <!--            type="textarea"-->
      <!--            :rows="4" />-->
      <!--        </div>-->

      <!-- Remarks -->
      <div class="form-item">
        <span>Excess Remark</span>
        <v-input
          v-model="formData.remark"
          type="textarea"
          :disabled="disabled"
          :rows="3"
          @blur="submitExcessData"/>
      </div>
    </template>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'ExcessForm',
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        tppd_ex: '',
        tppd_young_driver_ex: '',
        tppd_inexp_driver_ex: '',
        tppd_unnamed_driver_ex: '',
        remark: '',
        general_ex: '',
        general_ex_posi:'',
        general_ex_or_pol:'',
        // general_ex_vl: '',
        // general_ex_typ: '',
        china_general_ex: '',
        china_general_ex_posi: '',
        china_general_ex_or_pol: '',
        // china_general_ex_vl: '',
        // china_general_ex_typ: '',
        theft_loss_ex: '',
        theft_loss_ex_posi: '',
        theft_loss_ex_or_pol: '',
        // theft_loss_ex_vl: '',
        // theft_loss_ex_typ: '',
        china_theft_loss_ex: '',
        china_theft_loss_ex_posi: '',
        china_theft_loss_ex_or_pol: '',
        // china_theft_loss_ex_vl: '',
        // china_theft_loss_ex_typ: '',
        parking_damage_ex: '',
        young_driver_ex: '',
        inexp_driver_ex: '',
        unnamed_driver_ex: '',
        // gd_theft_loss_ex: '',
        // gd_theft_loss_ex_vl: '',
        // gd_theft_loss_ex_typ: '',
        // gd_general_ex: '',
        // gd_general_ex_vl: '',
        // gd_general_ex_typ: ''
      },
      excessCheckbox: {
        'general_ex': {
          status: false,
          vlKey: 'general_ex_vl',
          typKey: 'general_ex_typ'
        },
        'china_general_ex': {
          status: false,
          vlKey: 'china_general_ex_vl',
          typKey: 'china_general_ex_typ'
        },
        'theft_loss_ex': {
          status: false,
          vlKey: 'theft_loss_ex_vl',
          typKey: 'theft_loss_ex_typ'
        },
        'china_theft_loss_ex': {
          status: false,
          vlKey: 'china_theft_loss_vl',
          typKey: 'china_theft_loss_typ'
        },
        'gd_general_ex': {
          status: false,
          vlKey: 'gd_general_ex_vl',
          typKey: 'gd_general_ex_typ'
        },
        'gd_theft_loss_ex': {
          status: false,
          vlKey: 'gd_theft_loss_ex_vl',
          typKey: 'gd_theft_loss_ex_typ'
        },
      }
    }
  },
  computed: {
    classId() {
      return this.form.class_id
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
          this.$emit('getSubmitExcess',this.formData, this.index,false)
          // 初始化
          // Object.keys(this.excessCheckbox).some(key => {
          //   const { status, vlKey, typKey } = this.excessCheckbox[key]
          //   if(val[vlKey]) {
          //     this.excessCheckbox[key].status = true
          //   }
          // })
          // let {trm_of_cvr} = val||{}
          // if(trm_of_cvr==1){
          //   let arr =[
          //     'general_ex','general_ex_vl','general_ex_typ','china_general_ex','china_general_ex','china_general_ex_vl','china_general_ex_typ','gd_general_ex','gd_general_ex_vl','gd_general_ex_typ','theft_loss_ex',
          //     'theft_loss_ex_vl','theft_loss_ex_typ','china_theft_loss_ex','china_theft_loss_ex_vl','china_theft_loss_ex_typ','gd_theft_loss_ex','gd_theft_loss_ex_vl','gd_theft_loss_ex_typ','parking_damage_ex','young_driver_ex','inexp_driver_ex','unnamed_driver_ex'
          //   ]
          //   Object.keys(this.excessCheckbox).some(key => {
          //     this.excessCheckbox[key].status = false
          //   })
          //   arr.some(item=>{
          //     this.formData[item] =''
          //   })
          // }
        }
      }
    }
  },
  methods: {
    submitExcessData(){
      let params = JSON.parse(JSON.stringify(this.formData))
      this.$emit('getSubmitExcess',params, this.index,true)
    },
    submitForm() {
      // 整合數據
      let params = JSON.parse(JSON.stringify(this.formData))
      // Object.keys(this.excessCheckbox).some(key => {
      //   const { status, vlKey, typKey } = this.excessCheckbox[key]
      //   if(!status) {
      //     // delete params[vlKey]
      //     // delete params[typKey]
      //     // 傳空值出去，覆蓋父組件的數據
      //     params[vlKey] = ''
      //     params[typKey] = ''
      //   }
      // })
      // 後續傳出去
      this.$emit('getFormData', params)
      return params
    }
  }
}
</script>
<style lang="scss" scoped>
.excess-form {
  .flex-title{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292E;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
    .flex-excess {
            display: flex;
            align-items: center;
            & > .el-checkbox {
                margin: 0 15px;
            }
            & > span {
                display: inline-block;
                padding: 0 15px;
            }
        }
        .form-excess-half {
            width: 500px;
        }
}
</style>
